import $ from "jquery";
$(document).ready(function () {
  //Custom Select dropdown
  // $("select").each(function() {
  //   var $this = $(this),
  //     numberOfOptions = $(this).children("option").length;

  //   $this.addClass("select-hidden");
  //   $this.wrap('<div class="select"></div>');
  //   $this.after('<div class="select-styled"></div>');

  //   var $styledSelect = $this.next("div.select-styled");
  //   $styledSelect.text(
  //     $this
  //       .children("option")
  //       .eq(0)
  //       .text()
  //   );

  $(".noEnterSubmit").keypress(function (e) {
    if (e.which == 13) return false;
    //or...
  });
  

  //   var $list = $("<ul />", {
  //     class: "select-options",
  //   }).insertAfter($styledSelect);

  //   for (var i = 0; i < numberOfOptions; i++) {
  //     $("<li />", {
  //       text: $this
  //         .children("option")
  //         .eq(i)
  //         .text(),
  //       rel: $this
  //         .children("option")
  //         .eq(i)
  //         .val(),
  //     }).appendTo($list);
  //     //if ($this.children('option').eq(i).is(':selected')){
  //     //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
  //     //}
  //   }

  //   var $listItems = $list.children("li");

  //   $styledSelect.click(function(e) {
  //     e.stopPropagation();
  //     $("div.select-styled.active")
  //       .not(this)
  //       .each(function() {
  //         $(this)
  //           .removeClass("active")
  //           .next("ul.select-options")
  //           .hide();
  //       });
  //     $(this)
  //       .toggleClass("active")
  //       .next("ul.select-options")
  //       .toggle();
  //   });

  //   $listItems.click(function(e) {
  //     e.stopPropagation();
  //     $styledSelect.text($(this).text()).removeClass("active");
  //     $this.val($(this).attr("rel"));
  //     $list.hide();
  //     //console.log($this.val());
  //   });

  //   $(document).click(function() {
  //     $styledSelect.removeClass("active");
  //     $list.hide();
  //   });
  // });

  // $(".slick-arrow").click(function() {
  //   sliy();
  // });

  //for sidebar submenu

  // $(".dropdown").click(function() {
  //   $(this)
  //     .find(".sub-menu")
  //     .slideToggle();
  //   $(this)
  //     .siblings()
  //     .find(".sub-menu")
  //     .slideUp();
  //   $(this).toggleClass("dropdown-active");
  // });

  // $("header .header-right .search-box .form-group").append(
  //   '<div class="search-close"></div>'
  // );

  // chapter close
  $("#closeChapter").click(function () {
    $(".knowledge-chapter-left").toggleClass("empty");
    if ($(".knowledge-chapter-left").hasClass("empty")) {
      $(".knowledge-chapter-right-heading").css("opacity", "1");
    } else {
      $(".knowledge-chapter-right-heading").css("opacity", "0");
    }
  });

  //Attachment file for client

  $("#fileclient").on("change", function (e) {
    var labelVal = $(".clientfile").text();
    var oldfileName = $(this).val();
    let fileName = e.target.value.split("\\").pop();

    if (oldfileName === fileName) {
      return false;
    }
    var extension = fileName.split(".").pop();

    if (fileName) {
      if (fileName.length > 15) {
        $(".filelabel .clientfile").text(
          fileName.slice(0, 15) + "..." + extension
        );
      } else {
        $(".filelabel .clientfile").text(fileName);
      }
    } else {
      $(".filelabel .clientfile").text(labelVal);
    }
  });

  //Attachment file for cba
  $("#FileCba").on("change", function (e) {
    var labelVal = $(".cba-file").text();
    var oldfileName = $(this).val();
    let fileName = e.target.value.split("\\").pop();

    if (oldfileName === fileName) {
      return false;
    }
    var extension = fileName.split(".").pop();

    if (fileName) {
      if (fileName.length > 15) {
        $(".cbafilelabel .cba-file").text(
          fileName.slice(0, 15) + "..." + extension
        );
      } else {
        $(".cbafilelabel .cba-file").text(fileName);
      }
    } else {
      $(".cbafilelabel .cba-file").text(labelVal);
    }
  });

  // FAQ
});

export const FaqSideToggle = () => {
  let knowledgetab = document.querySelector(".knowledge-tab");
  // let knowledgeaccordData = document.querySelector('.knowledge-data');
  $("#tab-arrow").click(function () {
    // console.log("hif7weyu")
    knowledgetab.classList.toggle("active");
    // knowledgeaccordData.classList.toggle("knowledge_active");
  });

  // console.log("jkgiuky")
};
